// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24355":"dd9f77d5","37794":"c6935dab","56515":"aac9d932","76572":"569af593"}[chunkId] + ".chunk.css";
};